import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import TelemedicinePage from '@/components/pages/services/telemedicine';

const ProtectedTelemedicinePage = withAuthenticationRequired(TelemedicinePage, {
  onRedirecting: () => <Loading />,
});

export const Route = createFileRoute('/services/telemedicine')({
  head: () => ({
    meta: [{ title: `Telemedicine | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedTelemedicinePage,
});
